import React, { memo, useCallback } from 'react';
import classNames from 'classnames';
import Icon from '../icon';
const IconItem = function IconItem(props) {
    const { prefixCls, type, onSelect, active, customFontName } = props;
    const handleClick = useCallback(() => {
        onSelect(type);
    }, [type, onSelect]);
    return (React.createElement("li", { className: classNames({ [`${prefixCls}-item-selected`]: active }) },
        React.createElement("div", { onClick: handleClick },
            React.createElement(Icon, { customFontName: customFontName, type: type }),
            React.createElement("p", null, type))));
};
IconItem.displayName = 'IconItem';
export default memo(IconItem);
